var STATUS_WAITING = 2;
var STATUS_READY = 3;
var STATUS_VISUALIZE = 4;

(function ($, Promise) {

    // Constructor
    function VICCVisualize() {
      // console.log("VICCVisualize: constructor()");

      this.mainMap = false;
      this.pinchZoom = false;

      this.api = new VICCCloudAPI();
      this.breadcrumbs = new VICCVisualizeBreadcrumb();
      this.share = new VICCVisualizeShare();
      this.tryAnotherAddress = new VICCTryAnotherAddress();

      this.swiperSliders = [];
      this.swiperResults = [];
      this.selectedDisaster = false;
      this.isVisualisationReady = false;

      this.placename = false;
      this.isSameDisaster = false;
      this.isFirstSelection = true;

      this.visualizeTl = gsap.timeline();
    }

    /*
     * Triggered by Barba on page change
     */
    VICCVisualize.prototype.attach = function (dom) {
      // console.log("VICCVisualize: attach()");

      this.breadcrumbs.attach(dom);
      this.share.attach(dom);
      this.tryAnotherAddress.attach(dom);
      this.firstSearch = true;

      // Create maps
      this.mainMap = new VICCMap(document.getElementById("main-map-wrapper"));

      // Init maps
      if (app.googleMapReady) {
        this.mainMap.initMap();
      }

      // Visualize (results) - pinch zoom
      var pinchOptions = {};
      this.pinchZoom = new PinchZoom.default($('#visualize-fullscreen-container .visualize-fullscreen-wrapper')[0], pinchOptions);

      // Prepare DOM
      this.prepareDOM();

      // Init Swiper
      this.initSwiper();

      // Init Triggers
      this.initTrigger();

      // Resize
      $(window).on("resize", $.proxy(function () {
        this.resize();
      }, this));
    }

    /*
     * Prepare DOM
     */
    VICCVisualize.prototype.prepareDOM = function () {
      if (window.viewport().width <= 1000) {
        // Map CTA needs to be moved to respect design
        $("#main-map-wrapper .map-cta").appendTo("#main-map-wrapper").wrap("<div id='map-cta-wrapper' class='hidden'></div>");
        $("#overlay-map-wrapper .map-cta").appendTo("#overlay-map-wrapper").wrap("<div id='overlay-map-cta-wrapper' class='hidden'></div>");

        // Disaster selector moved to follow responsive design
        $(".visualize-disaster-selector").prependTo("#visualize-share-messages");
      }

      // Visualize result - Position of share widget
      if (window.viewport().width >= 1000) {
        $("#visualize-result-informations").css("marginTop", $("#visualize-result > .visualize-share-widget").outerHeight());
      }
    }

    /*
     * Init click events
     */
    VICCVisualize.prototype.initTrigger = function () {
      $(this.mainMap).off("selectAddress").on("selectAddress", $.proxy(function () {
        this.selectAddress();
      }, this));

      $(this.tryAnotherAddress.overlayMap).off("selectAddress").on("selectAddress", $.proxy(function (e) {
        this.updateAddress(e);
      }, this));

      // Launch experience, scroll to section
      $("#main-map-wrapper").on("click", ".cta-button", $.proxy(function (e) {
        e.preventDefault();
        this.gotoDisasterSelection();
      }, this));

      // Select a disaster, scroll to section
      $("#disaster-selector").off("click").on("click", ".disaster-trigger", $.proxy(function (e) {
        e.preventDefault();

        selectedDisaster = $(e.currentTarget).data("disaster");
        this.gotoDisasterInfo(selectedDisaster);
      }, this));

      // Breadcrumbs - select a disaster
      $(this.breadcrumbs).off("selectDisaster").on("selectDisaster", $.proxy(function (e, selectedDisaster) {
        this.gotoDisasterInfo(selectedDisaster, true);
      }, this));

      // Breadcrumbs - try another address
      $(this.breadcrumbs).off("tryAnotherAddress").on("tryAnotherAddress", $.proxy(function (e) {
        this.tryAnotherAddress.showOverlay();
      }, this));

      $(this.tryAnotherAddress).off("visualizationReady").on("visualizationReady", $.proxy(function (e, data) {
        this.visualizationReady(data)
      }, this));

      // Scroll to result using visualize status.
      $(".visualize-result-status.scroll-to").off("click").on("click", $.proxy(function () {
        VICC.prototype.scrollTo($("#visualize-result-container"), "html, body", 0);
      }, this));

      // Results - toggle fullscreen result overlay
      $("#visualize-result .visualize-result-slider, #visualize-fullscreen-container .visualize-fullscreen-close").off("click").on("click", $.proxy(function (e) {
        this.visualizationResultToggleOverlay(this.pinchZoom);
      }, this));
    }

    /*
     * Called by the Google Map API when it is ready to be used.
     */
    VICCVisualize.prototype.googleMapReady = function () {
      // console.log("VICCVisualize: googleMapReady()");
      this.mainMap.initMap();
      this.tryAnotherAddress.googleMapReady();
    }

    /*
     * Called when a new address is selected, whether when using the pin drag or the address input
     */
    VICCVisualize.prototype.selectAddress = function () {
      this.setStatus(STATUS_WAITING);
      this.breadcrumbs.setStatus(STATUS_WAITING);
      this.breadcrumbs.setStep(STEP_ADDRESS);

      // this.api.requestPreview(this.mainMap.lat, this.mainMap.lng).then($.proxy(this.updatePreviewImage, this)).catch(function (err) {
      //   console.error(err)
      // });

      this.updateAddress();

      // reset experience
      this.visualizationReset();
    }

    /*
     * Called when a new address is selected, whether when using the pin drag or the address input
     */
    VICCVisualize.prototype.updateAddress = function (e) {
      if (e !== undefined) {
        this.placename = this.tryAnotherAddress.overlayMap.placename;
      } else {
        this.placename = this.mainMap.placename;
      }
    }

    /*
     * Called when an address is confirmed.
     * Requests a visualization to the AI backend.
     */
    VICCVisualize.prototype.gotoDisasterSelection = function () {
      // console.log("VICCVisualize: gotoDisasterSelection()");

      // Prevent from redoing the same step that were already made
      if (this.breadcrumbs.breadcrumbStatus == STATUS_WAITING && !this.isVisualisationReady) {
        this.setStatus(STATUS_WAITING);
        this.breadcrumbs.setStatus(STATUS_WAITING);
        this.breadcrumbs.setStep(STEP_IMPACT_SELECT);
        this.api.requestVisualization(this.mainMap.lat, this.mainMap.lng).then($.proxy(this.visualizationReady, this));
      }

      $("#breadcrumb-item-preview").css("background", "url(" + this.mainMap.originalUrl + ") no-repeat center center");
      $("#breadcrumb-item-preview").css("background-size", "cover");

      // Animation
      this.visualizeTl.set("#disaster-wrapper", {
        height: 'auto',
      });
      this.visualizeTl.to("#disaster-selector", 0.5, {
        height: $("#disaster-selector #disaster-selector-infos").outerHeight(),
      });
      this.visualizeTl.add(function () {
        VICC.prototype.scrollTo("#disaster-selector");
        $("#disaster-selector").removeClass("hidden");
      }, "-=0.5");
    }

    /*
     * Called when user selects a disaster.
     * Used to define which DOM element to display
     */
    VICCVisualize.prototype.gotoDisasterInfo = function (selectedDisaster, skipScroll = false) {
      // console.log("VICCVisualize: gotoDisasterInfo()", selectedDisaster);

      // Variables
      var selectedDisasterHeight = $(".visualize-infos-content[data-disaster=" + selectedDisaster + "]").outerHeight() + $("#visualize-infos > #visualize-infos-process").outerHeight();
      this.isFirstSelection = this.selectedDisaster == false ? true : false;
      this.isSameDisaster = (this.selectedDisaster == selectedDisaster) ? true : false;
      this.selectedDisaster = selectedDisaster;
      this.share.selectedDisaster = selectedDisaster;

      if (this.breadcrumbs.step < STEP_IMPACT_INFOS) {
        this.breadcrumbs.setStep(STEP_IMPACT_INFOS);
      }
      this.breadcrumbs.setDisaster(selectedDisaster);

      // Update result DOM
      $(".visualize-result-flood:not(.swiper-slide):not(.fullscreen)").toggleClass("hidden", (selectedDisaster != "flood"));
      $(".visualize-result-wildfire:not(.swiper-slide):not(.fullscreen)").toggleClass("hidden", (selectedDisaster != "wildfire"));
      $(".visualize-result-smog:not(.swiper-slide):not(.fullscreen)").toggleClass("hidden", (selectedDisaster != "smog"));

      // Update disaster content
      if (this.isSameDisaster) {
        // Same disaster, just scroll
        if (!skipScroll) {
          VICC.prototype.scrollTo("#visualize #visualize-infos");
        }
      } else {
        $(".visualize-infos-content:not(.hidden)").addClass("hidden");
        $(".visualize-infos-content[data-disaster=" + selectedDisaster + "]").removeClass("hidden");

        // Add info in DOM to change content color
        $("#visualize").attr("data-disaster", selectedDisaster);

        // Hide current and show selected
        $("#visualize-infos").removeClass("hidden");

        // When choosing disaster from content
        if (!this.isFirstSelection && !skipScroll) {
          VICC.prototype.scrollTo("#visualize #visualize-infos");
        }

        // Refresh sliders
        // go back to first slide
        for (var i = 0; i < this.swiperSliders.length; i++) {
          this.swiperSliders[i].update();
          this.swiperSliders[i].slideTo(0);
        }

        // Animation
        this.visualizeTl.clear();

        // Change container height for new content
        $("#visualize-infos").height(selectedDisasterHeight);

        // FadeIn/FadeOut content
        this.visualizeTl.to(".visualize-infos-content.hidden", 0.5, {
          alpha: 0,
        });
        this.visualizeTl.to(".visualize-infos-content[data-disaster=" + selectedDisaster + "]", 0.5, {
          alpha: 1,
        });

        this.visualizeTl.add($.proxy(function () {

          // Scroll to content if it's the first selection, only happen after choosing an address
          if (this.isFirstSelection && !skipScroll) {
            VICC.prototype.scrollTo("#visualize #visualize-infos");

            // Add info in DOM to change content color
            $("#visualize").attr("data-disaster", selectedDisaster);
          }

          $(".visualize-result-status.scroll-to.hidden").removeClass("hidden");
        }, this), "-=1.5");

        // Change results slider slide
        if (this.swiperResults.length) {
          this.swiperResults[1].slideTo($(".visualize-result-slider .swiper-slide[class*=" + this.selectedDisaster + "]").index());
        }

        // Quickly scroll to visualization results section because previous content is moving
        if (skipScroll) {
          window.scrollTo(0, ($("#visualize-infos").offset().top + $("#disaster-wrapper > .visualize-result-status").outerHeight() + selectedDisasterHeight) - $("#header").outerHeight() + 2);

          // Change results slider slide
          if (this.swiperResults.length) {
            this.swiperResults[1].slideTo($(".visualize-result-slider .swiper-slide[class*=" + this.selectedDisaster + "]").index());
          }
        }
      }

      // Show result section if visualization is already completed
      if (this.isVisualisationReady && this.selectedDisaster) {
        gsap.to("#visualize-result-container", 0.5, {
          height: $("#visualize-result").outerHeight(),
        });
        $("#visualize-result-container").removeClass("hidden");
      }
    }

    /*
     * Set the status of the visualization.
     * Can be "waiting" or "ready"
     */
    VICCVisualize.prototype.setStatus = function (status) {
      $(".visualize-result-status .visualize-result-status-waiting").toggleClass("hidden", status != STATUS_WAITING);
      $(".visualize-result-status .visualize-result-status-ready").toggleClass("hidden", status != STATUS_READY);

      if (status == STATUS_WAITING) {
        this.isVisualisationReady = false;
        $("#visualize-result-container").addClass("hidden");
      }
    }

    /*
     * Promise callback when the visualisation is ready
     */
    VICCVisualize.prototype.visualizationReady = function (data) {
      // console.log("visualizationReady", data);
      this.share.currentHash = data.uniqueName;
      this.setStatus(STATUS_READY);
      this.breadcrumbs.setStatus(STATUS_READY);
      this.isVisualisationReady = true;

      var $img_flood = $("<img src='" + data.floodUrl + "' />");
      var $img_wildfire = $("<img src='" + data.wildfireUrl + "' />");
      var $img_smog = $("<img src='" + data.smogUrl + "' />");

      $(".visualize-result-flood").empty().append($img_flood);
      $(".visualize-result-wildfire").empty().append($img_wildfire);
      $(".visualize-result-smog").empty().append($img_smog);

      // Changing img affect the container height, need to wait for loading
      $img_smog.off("load").one("load", $.proxy(function () {

        // Refresh swiper
        if (this.swiperResults.length) {
          // Update doesn't seem to work while container is animating, need delay
          setTimeout($.proxy(function () {
            this.swiperResults[1].update();
            this.swiperResults[1].thumbs.update();
            this.swiperResults[0].update();

            // if a disaster have been selected
            if (this.selectedDisaster) {
              gsap.to("#visualize-result-container", 1, {
                height: $("#visualize-result").outerHeight(),
              });
              $("#visualize-result-container").removeClass("hidden");
            }
          }, this), 1500);
        } else {
          // if a disaster have been selected
          if (this.selectedDisaster) {
            gsap.to("#visualize-result-container", 1, {
              height: $("#visualize-result").outerHeight(),
            });
            $("#visualize-result-container").removeClass("hidden");
          }
        }
      }, this)).each(function () {
        if (this.complete) {
          $(this).trigger('load');
        }
      });
    }

    /*
     * Reset visualization experience without loading the page
     */
    VICCVisualize.prototype.visualizationReset = function () {
      this.selectedDisaster = false;
      this.isVisualisationReady = false;
      this.sameDisaster = false;
      this.isFirstSelection = true;
      this.share.currentHash = false;
      this.share.selectedDisaster = false;

      $("#disaster-selector, .visualize-infos-content, #visualize-infos, .visualize-result-status.scroll-to, #visualize-result-container").addClass("hidden");

      // Reset sections height
      this.visualizeTl.to("#visualize #disaster-wrapper", 0.5, {
        height: 0,
      });
      this.visualizeTl.set("#disaster-selector, #visualize-infos, #visualize-result-container", {
        height: 0,
      });
    }

    VICCVisualize.prototype.initSwiper = function () {

      // Init sliders
      $.each($(".swiper-container:not(.visualize-result-slider):not(.swiper-thumbs)"), $.proxy(function (index, el) {
        if (!$(el).is(".swiper-container-initialized")) {
          this.swiperSliders.push(new Swiper($(el)[0], {
            loop: true,
            slidesPerView: 1.5,
            spaceBetween: 10,
            centeredSlides: true,
            autoHeight: true,
            grabCursor: true,
            slideToClickedSlide: true,
            accessibility: false,
            threshold: 20,

            // Navigation
            navigation: {
              prevEl: $(el).parents(".slider-container").find('.swiper-prev')[0],
              nextEl: $(el).parents(".slider-container").find('.swiper-next')[0]
            },
          }));
        }
      }, this));

      // Visualize results
      if ($(".swiper-container.visualize-result-slider").length && !$(".swiper-container.visualize-result-slider").is(".swiper-container-initialized")) {

        this.swiperResults.push(new Swiper('.visualize-result-wrapper .swiper-thumbs', {
          direction: 'horizontal',
          slidesPerView: 3,
          allowTouchMove: false,
          threshold: 20,

          breakpoints: {
            550: {
              direction: 'vertical',
            }
          },

          on: {
            click: function (swiper) {
              $("#visualize-result .visualize-result-slider").css("pointer-events", "none");
              $("#breadcrumb-disaster-selector > li").eq(swiper.clickedIndex).trigger("click");

              setTimeout(function () {
                $("#visualize-result .visualize-result-slider").css("pointer-events", "auto");
              }, 250);
            }
          }
        }));

        this.swiperResults.push(new Swiper($(".swiper-container.visualize-result-slider")[0], {
          slidesPerView: 1,
          allowTouchMove: false,
          accessibility: false,
          threshold: 20
        }));
      }

    }

    VICCVisualize.prototype.visualizationResultToggleOverlay = function (pinchObj) {
      if (window.viewport().width >= 1000) {
        return;
      }

      if ($("#visualize-fullscreen-container").is(".shown")) {
        $("#visualize-fullscreen-container").removeClass("shown");
        pinchObj.disable();
      } else {

        // Update visible image based on slider
        if (this.swiperResults.length) {
          $("#visualize-fullscreen-container .visualize-result-disaster").eq(this.swiperResults[1].realIndex).removeClass("hidden").siblings().addClass("hidden");
        }

        // Reset zoom
        $(pinchObj.el).css({
          "transform": "scale(1, 1) translate(0px, 0px)",
          "transform-origin": "0% 0%"
        })
        pinchObj.lastScale = 1;
        pinchObj.zoomFactor = 1;
        pinchObj.offset = {
          x: -0,
          y: -0
        }

        // Delete properties, will be automatically added on the next zoom
        delete pinchObj.lastDragPosition;
        delete pinchObj.lastScale;
        delete pinchObj.lastZoomCenter;
        delete pinchObj.nthZoom;

        $("#visualize-fullscreen-container").addClass("shown");
        pinchObj.enable();
      }
    }

    VICCVisualize.prototype.resize = function () {

      // Recalculate sections height
      $("#disaster-selector:not(.hidden)").height($("#disaster-selector #disaster-selector-infos").outerHeight());
      $("#visualize-infos:not(.hidden)").height($(".visualize-infos-content[data-disaster=" + this.selectedDisaster + "]").outerHeight() + $("#visualize-infos > .visualize-result-status").outerHeight());
      $("#visualize-result-container:not(.hidden)").height($("#visualize-result").outerHeight());

      // Visualize result - Position of share widget
      if (window.viewport().width < 1000) {
        $("#visualize-result-informations").css("marginTop", "0px");
      } else {
        $("#visualize-result-informations").css("marginTop", $("#visualize-result > .visualize-share-widget").outerHeight());
      }

      // Visualize result - recalculate height
      $("#visualize-result-container:not(.hidden)").height($("#visualize-result").outerHeight());

    }

    VICCVisualize.prototype.dettach = function () {
      // console.log("VICCVisualize: dettach()", this);

      if (this.mainMap) {
        this.mainMap.destroy();
      }

      this.tryAnotherAddress.dettach();
      this.breadcrumbs.dettach();
      this.share.dettach();

      // Remove file monitors (HEAD timed querys)
      this.api.clearMonitors();

      // remove google autocomplete
      $(".pac-container").remove();

      // reset variables
      this.pinchZoom = false;
      this.currentHash = false;
      this.selectedDisaster = false;
      this.isVisualisationReady = false;
      this.isSameDisaster = false;
      this.isFirstSelection = true;

      this.placename = false;

      this.visualizeTl.kill();

      // Destroy sliders
      for (var i = 0; i < this.swiperSliders.length; i++) {
        this.swiperSliders[i].destroy();
        if (i == this.swiperSliders.length - 1) {
          this.swiperSliders = [];
        }
      }
      for (var i = 0; i < this.swiperResults.length; i++) {
        this.swiperResults[i].destroy();
        if (i == this.swiperResults.length - 1) {
          this.swiperResults = [];
        }
      }

      $(window).off("resize", $.proxy(function () {
        this.resize();
      }, this));
    }

    // Expose VICCVisualize
    window.VICCVisualize = VICCVisualize;

  }
)
(jQuery, Promise);
